const trainingSessionsForTraining = (state) => (id) => {
    if(state.trainings && state.trainings[id]) {
        return state.trainings[id].session_id_list.map(sessionId => {
            return state.trainingSessions[sessionId];
        });
    }
    return [];
}

const trainingsInModule = (state) => (module_id) => {
    if(state.trainings) {
        return Object.values(state.trainings).filter(t => {
            if(t.module && t.module.id) {
                return t.module.id == module_id;
            }
            return false;
        });
    }
    return [];
}


export default {
    trainingSessionsForTraining,
    trainingsInModule,
};